import { useState } from "react";

export default function RegistrationForm() {
  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    email: "",
    title: "",
    country: "",
    province: "",
    profession: "",
    specialty: "",
    entity: "",
    position: "",
    telephone: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/guardar_inscripcion.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        alert("An error occurred. Please try again.");
      }
    } catch (error) {
      alert("Could not connect to the server.");
    }
  };

  if (submitted) {
    return (
      <div className="max-w-xl mx-auto text-center text-lg text-green-700">
        Thank you for registering!<br/>
        We will contact you shortly by mail including a payment link.<br/>
        You may still contact as by email: congresos@travelmark.com <br /> or via WhatsApp: +54 11 2748 1955
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-2xl mx-auto grid grid-cols-1 gap-4"
    >
      {[
        ["lastName", "Last Name"],
        ["firstName", "First Name"],
        ["email", "Email", "email"],
        ["title", "Title"],
        ["country", "Country"],
        ["province", "Province"],
        ["profession", "Profession"],
        ["specialty", "Specialty"],
        ["entity", "Entity"],
        ["position", "Position"],
        ["telephone", "Telephone", "tel"],
      ].map(([name, label, type = "text"]) => (
        <div key={name}>
          <label className="block font-medium mb-1" htmlFor={name}>
            {label}
          </label>
          {name === "title" ? (
            <select
              id={name}
              name={name}
              required
              value={formData[name]}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
            >
              <option value="">-- Select a title --</option>
              <option value="Prof.">Prof.</option>
              <option value="Dr.">Dr.</option>
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
              <option value="Miss">Miss</option>
              <option value="Ms.">Ms.</option>
            </select>
          ) : (
            <input
              type={type}
              name={name}
              id={name}
              required
              value={formData[name]}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded px-3 py-2"
            />
          )}
        </div>
      ))}

      <button
        type="submit"
        className="bg-teal-700 text-white py-2 px-6 rounded-xl font-semibold shadow hover:bg-teal-800 transition"
      >
        Submit Registration
      </button>
    </form>
  );
}
